<template>
  <svg width="12px" height="12px" viewBox="0 0 12 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <desc>Created with sketchtool.</desc>
    <defs>
      <path
        d="M0,6 C0,4.75788853 0.37499625,3.65263642 1.125,2.68421053 C1.87500375,1.71578463 2.8333275,1.084212 4,0.789473684 L4,2.17894737 C3.20832937,2.47368568 2.56771078,2.96841758 2.078125,3.66315789 C1.58853922,4.35789821 1.34375,5.13683779 1.34375,6 C1.34375,7.11579505 1.72916281,8.063154 2.5,8.84210526 L4,7.35789474 L4,11.4 L0,11.4 L1.5625,9.78947368 C0.520828125,8.73683684 0,7.47369158 0,6 Z M5.34375,9.37894737 L5.34375,8.02105263 L6.65625,8.02105263 L6.65625,9.37894737 L5.34375,9.37894737 Z M12,0.6 L10.4375,2.21052632 C11.4791719,3.26316316 12,4.52630842 12,6 C12,7.24211147 11.6250037,8.34736358 10.875,9.31578947 C10.1249962,10.2842154 9.1666725,10.915788 8,11.2105263 L8,9.82105263 C8.79167062,9.52631432 9.43228922,9.03158242 9.921875,8.33684211 C10.4114608,7.64210179 10.65625,6.86316221 10.65625,6 C10.65625,4.88420495 10.2708372,3.936846 9.5,3.15789474 L8,4.64210526 L8,0.6 L12,0.6 Z M5.34375,6.66315789 L5.34375,2.62105263 L6.65625,2.62105263 L6.65625,6.66315789 L5.34375,6.66315789 Z"
        id="compare-path"
      ></path>
    </defs>
    <g id="Guidelines-/-WebOrion" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="Web-/-6.2_Incident_Detail" transform="translate(-296.000000, -670.000000)">
        <g id="Group" transform="translate(240.000000, 60.000000)">
          <g transform="translate(0.000000, 60.000000)" id="Button">
            <g transform="translate(20.000000, 90.000000)">
              <g transform="translate(20.000000, 450.000000)">
                <g id="🌗-Content" transform="translate(10.000000, 6.000000)">
                  <g id="Group" transform="translate(6.000000, 2.000000)">
                    <g id="🌐-Icon-Left" transform="translate(0.000000, 2.000000)">
                      <mask id="compare-mask" fill="white">
                        <use xlink:href="#compare-path"></use>
                      </mask>
                      <g id="ic_action_sync_alert" fill-rule="nonzero"></g>
                      <g id="Color" mask="url(#compare-mask)" fill="currentColor">
                        <rect id="■-Color" x="0" y="0" width="12" height="12"></rect>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'CompareIcon'
  };
</script>

<style lang="scss" scoped>
  svg {
    vertical-align: middle;
  }
  svg:hover {
    fill: currentColor;
  }
</style>
